import { TimesheetRow } from "./TimesheetRow";

interface TimesheetFieldProps {
  label: string;
  verifiedValue: string;
  proposedValue?: string;
  showRequested: boolean;
  hasError?: boolean;
}

export function TimesheetField(props: TimesheetFieldProps) {
  const { label, verifiedValue, proposedValue, showRequested, hasError } = props;

  if (showRequested) {
    return (
      <>
        <TimesheetRow bold label={`Requested ${label.toLowerCase()}`} value={proposedValue ?? ""} />
        <TimesheetRow muted label={`Original ${label.toLowerCase()}`} value={verifiedValue} />
      </>
    );
  }

  return <TimesheetRow label={label} value={verifiedValue} hasError={hasError} />;
}
